export enum DeduccionModalTypes {
    OPEN_DEDUCCION_MODAL = '[auth] OPEN_DEDUCCION_MODAL',
    CLOSE_DEDUCCION_MODAL = '[auth] CLOSE_DEDUCCION_MODAL',
    REACTIVE_DEDUCCION_COL = '[auth] REACTIVE_DEDUCCION_COL',
    UPDATE_DEDUCCION = '[auth] UPDATE_DEDUCCION'
}